import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
import { AppState } from 'app/App Store/state';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import swal from "sweetalert2";

@Component({
  selector: 'app-new-report',
  templateUrl: './new-report.component.html',
  styleUrls: ['./new-report.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewReportComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 10,
    totalPages: 0,
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = "";
  isFilter: boolean = false;
  public columns = [
    { name: "Name", prop: "displayname" },
    { name: "Type", prop: "type" },
    { name: "References", prop: "references" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = [];

  imageUrl = environment.apiUrls.imageUrl;

  assets_id: any;
  searchVal: any;
  @ViewChild("name") inputName;
  user_role: any;

  guideline_data: any;
  update_password: any;
  read_password: any;
  gig_tags_list = []
  selected_gig_tag = null
  type_list = [
    { name: "Portfolio", id: "portfolio" },
    { name: "Product", id: "product" },
    { name: "Project Analysis Document", id: "pad" },
    { name: "Topic Analysis Document", id: "tad" },
    { name: "Portfolio Feature Document", id: "pfd" },
    { name: "Bundle Feature Document", id: "bfd" },
    { name: "Research", id: "research" },
    { name:"Gigs", id:"gigs"}
  ];
  selected_type = null;
   skillId = "6319d3595ab9e462a96cfb06";
  skills_tag_List = [];
  selected_skill = null;
  current_data: any
  skills_keywords_List = [];
  features_keywords_List = [];
  projects_keywords_List = [];
  selected_skills_keywords = null
  selected_features_keywords = null
  selected_projects_keywords = null
  isCollapsedSkills = false;
  isCollapsedFeatures = false;
  isCollapsedProjects = false;
  modal_prop:any
  update_prop: any
  updated_data: any
  isUpdateName: boolean = false
  isUpdateNotes: boolean = false
  isUpdateAdminNotes: boolean = false
  isUpdateSkills: boolean = false
  isUpdateFeatures : boolean = false
  isUpdateProjects : boolean = false
  isAddSkillKeyword: boolean = false
  isAddfeaturesKeyword: boolean = false
  isAddProjectsKeyword: boolean = false
  skill_keywords:any = []
  features_keywords:any  = []
  projects_keywords:any  = []
  empType: any = []
  domain_list = []
  selected_domain = null
  pageNumberSubscription : Subscription
  current_row:any
  selected_keyword="skill"
  keywords_list=[
    {name:"Skill",id:"skill"},
    {name:"Features",id:"features"},
    {name:"Projects",id:"projects"}
  ]
  public taskView: boolean[] = [];
  pagedRows = []; 
  row_data:any
  old_keyword:any
  selected_new_keyword = null
  all_keywords =[]
  constructor(
    public apiService: ApiService,
    private router: Router,
    private modalService: NgbModal,
    public toastr: ToastrService,
    private spinner: NgxSpinnerService,private store: Store<AppState>,private route: ActivatedRoute,
    private cdr : ChangeDetectorRef
  ) {
    this.user_role = JSON.parse(localStorage.getItem("user"));
    if (this.user_role.roles !== "admin") {
      this.empType = JSON.parse(localStorage.getItem("empType"));
      this.empType = this.empType.map(item =>item.displayname)
    }
    let setting_data = JSON.parse(localStorage.getItem("setting-record"));
    let key_data = setting_data.filter((item) => item.key == "Digital Assets");
    this.guideline_data = key_data[0]?._id;

    this.route.queryParamMap.subscribe((params) => {
      let page = +params.get('page');
      this.setPage(page)
    });
    this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
    .subscribe(pageNumber => {
      this.page.pageNumber = pageNumber;
      if(pageNumber !==undefined){
        this.page.pageNumber = pageNumber -1
      }
      if(pageNumber === 0) this.page.pageNumber = 0
      
    });
  }

  ngOnInit(): void {
    // this.getAllCategory()
    // this.getSkillTagByCategory()
    this.getAllAssets();
    this.getKeywords()

    // this.getAllSettings();
  }
setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getAllSettings() {
    this.apiService.getAllSetting(1, 100).subscribe((res: any) => {
      let update_password = res?.items?.filter(
        (item) => item.key == "update_assets_password"
      );
      this.update_password = update_password[0]?.value;
      let read_password = res?.items?.filter(
        (item) => item.key == "read_assets_password"
      );
      this.read_password = read_password[0]?.value;
    });
  }
  getAllAssets() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    let keyword1 = '';
    let keyword2 = '';
    let keyword3 = '';
    if (this.selected_keyword == 'skill') {
      keyword1 = this.selected_keyword;
    } else if (this.selected_keyword == 'features') {
      keyword2 = this.selected_keyword;
    }else if (this.selected_keyword == 'projects') {
      keyword3 = this.selected_keyword;
    }
    this.apiService
      .getAllAssetsKeyword(this.page.pageNumber +1 ,1000,keyword1,keyword2,keyword3)
      .subscribe((res: any) => {
        this.spinner.hide();
        if(this.selected_keyword === 'skill'){
          let data = res.data.items;
          this.rows = data?.flatMap((item) => 
            item.skill_keywords.map(skill => ({
              name: skill.name,
              count: skill.count,
              keyword_type: "skill",
              type: item.type,
              _id: item._id
  
            }))
          );
          this.page.totalPages = this.rows.length
          const maxPage = Math.ceil(this.page.totalPages / this.limitRef);
          if (this.page.pageNumber > maxPage) {
            this.page.pageNumber = maxPage;
          }
          this.updatePagedRows(); // Update paged data
          setTimeout(() => {
            if (this.table) {
              this.table.recalculate(); // Ensure pagination updates correctly
            }
          }, 100);
        }
        if(this.selected_keyword === 'features'){
          let data = res.data.items;
          this.rows = data?.flatMap((item) => 
            item.features_keywords.map(skill => ({
              name: skill.name,
              count: skill.count,
              keyword_type: "features",
              type: item.type,
              _id: item._id
  
            }))
          );
            this.page.totalPages = this.rows.length
          const maxPage = Math.ceil(this.page.totalPages / this.limitRef);
          if (this.page.pageNumber > maxPage) {
            this.page.pageNumber = maxPage;
          }
          this.updatePagedRows(); // Update paged data
          setTimeout(() => {
            if (this.table) {
              this.table.recalculate(); // Ensure pagination updates correctly
            }
          }, 100);
        }
        if(this.selected_keyword === 'projects'){
          let data = res.data.items;
          this.rows = data?.flatMap((item) => 
            item.projects_keywords.map(skill => ({
              name: skill.name,
              count: skill.count,
              keyword_type: "projects",
              type: item.type,
              _id: item._id
  
            }))
          );
            this.page.totalPages = this.rows.length
          const maxPage = Math.ceil(this.page.totalPages / this.limitRef);
          if (this.page.pageNumber > maxPage) {
            this.page.pageNumber = maxPage;
          }
          this.updatePagedRows(); // Update paged data
          setTimeout(() => {
            if (this.table) {
              this.table.recalculate(); // Ensure pagination updates correctly
            }
          }, 100);
        }
      });
      
  }
  pageChangeData(page: any) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    let keyword1 = '';
    let keyword2 = '';
    let keyword3 = '';
    if (this.selected_keyword === 'skill') {
      keyword1 = this.selected_keyword;
    } else if (this.selected_keyword === 'features') {
      keyword2 = this.selected_keyword;
    }else if (this.selected_keyword === 'projects') {
      keyword3 = this.selected_keyword;
    }
   
    this.apiService
    .getAllAssetsKeyword(this.page.pageNumber +1 ,this.limitRef,keyword1,keyword2,keyword3)
    .subscribe((res: any) => {
      this.spinner.hide();
      if(this.selected_keyword === 'skill'){
        let data = res.data.items;
        this.rows = data?.flatMap((item) => 
          item.skill_keywords.map(skill => ({
            name: skill.name,
            count: skill.count,
            keyword_type: "skill",
            type: item.type,
            _id: item._id

          }))
        );
        this.page.totalPages = this.rows.length
        const maxPage = Math.ceil(this.page.totalPages / this.limitRef);
        if (this.page.pageNumber > maxPage) {
          this.page.pageNumber = maxPage;
        }
        this.updatePagedRows(); // Update paged data
        setTimeout(() => {
          if (this.table) {
            this.table.recalculate(); // Ensure pagination updates correctly
          }
        }, 100);
      }
      if(this.selected_keyword === 'features'){
        let data = res.data.items;
        this.rows = data?.flatMap((item) => 
          item.features_keywords.map(skill => ({
            name: skill.name,
            count: skill.count,
            keyword_type: "features",
            type: item.type,
            _id: item._id

          }))
        );
          this.page.totalPages = this.rows.length
          const maxPage = Math.ceil(this.page.totalPages / this.limitRef);
          if (this.page.pageNumber > maxPage) {
            this.page.pageNumber = maxPage;
          }
          this.updatePagedRows(); // Update paged data
          setTimeout(() => {
            if (this.table) {
              this.table.recalculate(); // Ensure pagination updates correctly
            }
          }, 100);
      }
      if(this.selected_keyword === 'projects'){
        let data = res.data.items;
        this.rows = data?.flatMap((item) => 
          item.projects_keywords.map(skill => ({
            name: skill.name,
            count: skill.count,
            keyword_type: "projects",
            type: item.type,
            _id: item._id

          }))
        );
          this.page.totalPages = this.rows.length
          const maxPage = Math.ceil(this.page.totalPages / this.limitRef);
          if (this.page.pageNumber > maxPage) {
            this.page.pageNumber = maxPage;
          }
          this.updatePagedRows(); // Update paged data
          setTimeout(() => {
            if (this.table) {
              this.table.recalculate(); // Ensure pagination updates correctly
            }
          }, 100);
      }
    });
  } 

  resetFilter() {
    this.inputName.nativeElement.value = "";
    this.searchVal ="";
    this.page.pageNumber =0
    this.getAllAssets();
  }

  delete(password) {
    if (password) {
      this.apiService
        .deleteAssets(this.assets_id, password)
        .subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.getAllAssets();
            swal.fire({
              title: "Success",
              text: "Student deleted successfully !",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          } else {
            swal.fire({
              title: "Cancelled",
              text: `${res.error}`,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        });
    } else {
      this.toastr.error("Something went wrong !");
    }
  }

  // ================== Delete Alert ========================
  ConfirmColor(id: any) {
    this.assets_id = id;
    swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.delete(result.value);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }

  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  confirmUpdate(id: any, prop, content) {
    const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
    const storedDate = localStorage.getItem('passwordPromptDate');
    const passwordEntered = localStorage.getItem('passwordEntered');

    if (storedDate === today && passwordEntered === 'true' && content) {
      // Password has already been entered today, skip the prompt
      if (prop == "view") this.goToDetailPage(id, null, content);
    }
    else {
      swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          localStorage.setItem('passwordPromptDate', today);
          localStorage.setItem('passwordEntered', 'true');
          if (prop == "update" && !content) this.updateAssets(id, result.value);
          if (prop == "view" && content) this.goToDetailPage(id, result.value,content);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Cancel",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
     }
    
  }
  updateAssets(id, password) {
    if (password == this.update_password) {
      this.router.navigate(["assets/edit", id]);
    } else {
      swal.fire({
        title: "Error",
        text: "Incorrect Password!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }
  goToDetailPage(data, password,content) {
    if (content) {
      this.current_data = data
      // this.router.navigate(["assets/view", id]);
      const options: NgbModalOptions = {
      size: "xl", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.current_data =null
      },
      (reason) => {
        this.current_data =null
      }
    );
    } else {
      swal.fire({
        title: "Error",
        text: "Incorrect Password!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }
  getAllCategory() {
    this.apiService.getAllCategory(1,100).subscribe((res: any) => {
      let data = res?.data?.items?.filter((item) => item?.name === 'Gig Keyword')
      let skill_keywords = res?.data?.items?.filter((item) => item?.name === 'Skill Keywords')
      let features_keywords = res?.data?.items?.filter((item) => item?.name === 'Features Keywords')
      let projects_keywords = res?.data?.items?.filter((item) => item?.name === 'Projects Keywords')
      let domain_tags = res?.data?.items?.filter((item) => item?.name === 'Domain')
     
      if(data) this.getAllGigTags(data[0]._id)
      if(skill_keywords) this.getAllSkillKeywordsTags(skill_keywords[0]._id)
      if(features_keywords) this.getAllFeaturesKeywordsTags(features_keywords[0]._id)
      if (projects_keywords) this.getAllProjectsKeywordsTags(projects_keywords[0]._id)
      if(domain_tags) this.getAllDomainTags(domain_tags[0]._id)
    })
  }
  getAllGigTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.gig_tags_list = res.data;
    });
  }
  getAllDomainTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.domain_list = res.data;
    });
  }
  getAllSkillKeywordsTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.skills_keywords_List = res.data;
    });
  }
  getAllFeaturesKeywordsTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.features_keywords_List = res.data;
    });
  }
  getAllProjectsKeywordsTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.projects_keywords_List = res.data;
    });
  }
  getTypeId(event) {
    this.selected_type
    // this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  getGigId(event) {
    this.selected_gig_tag
    // this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
   getDomainId(event) { 
     this.selected_domain
    //  this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  getSkillTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res: any) => {
      this.skills_tag_List = res.data;
    });
  }
  // getSkillTagsId(event: any) {
  //   this.selected_skill;
  //   this.filterAssets('',this.selected_type,this.selected_gig_tag,selected_skills_keywords,selected_features_keywords,selected_projects_keywords)
  // }
  getSkillKeywordsTagsId(event: any) {
    this.selected_skills_keywords;
    // this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  getFeaturesKeywordsTagsId(event: any) {
    this.selected_features_keywords;
    // this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  getProjectsKeywordsTagsId(event: any) {
    this.selected_projects_keywords;
    // this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  goToKeywords(data,prop,content){
    if(prop == 'skill'){
      this.modal_prop = prop
      this.current_data = data
    }
    if(prop == 'feature'){
      this.modal_prop = prop
      this.current_data = data
    }
    if(prop == 'project'){
      this.modal_prop = prop
      this.current_data = data
    }
      // this.router.navigate(["assets/view", id]);
      const options: NgbModalOptions = {
      size: "xl", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.current_data =null
        this.modal_prop = null
      },
      (reason) => {
        this.current_data =null
        this.modal_prop = null
      });
  }
  updateTags(id,tag_id) {
    
    let body = {
      category: tag_id
    }
    this.apiService.updateAssets(id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Tags updated successfully');
        this.getAllAssets();
      }
    });
  }
  updateDomain(id,tag_id) {
    
    let body = {
      domain: tag_id
    }
    this.apiService.updateAssets(id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Domain updated successfully');
        this.getAllAssets();
      }
    });
  }
  updateType(id,type_id) {
    let body = {
      type: type_id
    }
    this.apiService.updateAssets(id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Type updated successfully');
        this.getAllAssets();
      }
    });
  }
  editItem(id,data,prop) {
    this.update_prop = prop
    if (this.update_prop == 'name') { 
      this.assets_id = id
      this.isUpdateName = !this.isUpdateName
      this.updated_data = data
    }
    if (this.update_prop == 'notes') { 
      this.assets_id = id
      this.isUpdateNotes = !this.isUpdateNotes
      this.updated_data = data
    }
    if (this.update_prop == 'admin notes') { 
      this.assets_id = id
      this.isUpdateAdminNotes = !this.isUpdateAdminNotes
      this.updated_data = data
    }
    if (this.update_prop == 'skill') { 
      this.assets_id = id
      this.isUpdateSkills = !this.isUpdateSkills
      this.skill_keywords = data
    }
    if (this.update_prop == 'feature') { 
      this.assets_id = id
      this.isUpdateFeatures = !this.isUpdateFeatures
      this.features_keywords = data
    }
    if (this.update_prop == 'project') { 
      this.assets_id = id
      this.isUpdateProjects = !this.isUpdateProjects
      this.projects_keywords = data
    }
  }
  update(prop) {
    if(prop == 'name'){
        let body = {
        name: this.updated_data
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateName = false
          this.updated_data = ''
          this.toastr.success('Name updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'notes'){
        let body = {
        notes: this.updated_data
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateNotes = false
          this.updated_data = ''
          this.toastr.success('Notes updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'admin notes'){
        let body = {
        admin_notes: this.updated_data
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateAdminNotes = false
          this.updated_data = ''
          this.toastr.success('Admin notes updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'skill'){
        let body = {
           skill_keywords: this.skill_keywords
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateSkills = false
          this.isAddSkillKeyword = false
          this.skill_keywords = ''
          this.toastr.success('skills updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'feature'){
        let body = {
           features_keywords: this.features_keywords
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateFeatures = false
          this.isAddfeaturesKeyword = false
          this.features_keywords = []
          this.toastr.success('features updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'project'){
        let body = {
           projects_keywords: this.projects_keywords
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateProjects = false
          this.isAddProjectsKeyword = false
          this.projects_keywords = []
          this.toastr.success('projects updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    
    
  }
 
  addKeyword(data: string, prop: string) {
    // Split data by commas, trim whitespace, and filter out empty strings
    const keywords = data?data.split(',')
                          .map(keyword => keyword.trim())
                          .filter(keyword => keyword):[];
    // Use switch to handle different properties
    switch (prop) {
      case "skill":
        if (!Array.isArray(this.skill_keywords)) {
          this.skill_keywords = [];
        }
        this.skill_keywords.push(...keywords);
        this.update(prop);
        break;
      case "feature":
        if (!Array.isArray(this.features_keywords)) {
          this.features_keywords = [];
        }
        this.features_keywords.push(...keywords);
        this.update(prop);
        break;
      case "project":
        if (!Array.isArray(this.projects_keywords)) {
          this.projects_keywords = [];
        }
        this.projects_keywords.push(...keywords);
        this.update(prop);
        break;
      default:
        console.error(`Unknown property: ${prop}`);
        break;
    }
  }
removeKeyword(indx: any, prop: any) {
  switch (prop) {
    case "skill":
      this.skill_keywords.splice(indx, 1)
      break;
    case "feature":
      this.features_keywords.splice(indx, 1)
      break;
    case "project":
      this.projects_keywords.splice(indx, 1)
      break;
  }
}
copyItem(id){
  let url = `https://do.meander.software/digital-assets/${id}`
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = url
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.toastr.info('copy digital assets url')
}
openModal(content, data) {
  const options: NgbModalOptions = {
    size: 'lg', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  this.current_row = data
  this.modalService.open(content, options); // open the modal
}
getKeywordId(event){
  this.selected_keyword
  this.page.pageNumber =0
  this.getAllAssets()
}
onPage(event) {
  this.page.pageNumber = event.offset + 1; // Adjusting because ngx-datatable starts counting from 0
  this.updatePagedRows(); // Update the rows when the page changes
}

// This method updates paged rows based on the current page and limit
updatePagedRows() {
  if (this.page.pageNumber <= 0) {
    this.page.pageNumber = 1; // Ensure page number is never 0
  }

  const start = (this.page.pageNumber - 1) * this.limitRef;
  const end = start + this.limitRef;
  this.pagedRows = this.rows.slice(start, end); // Get paginated data

  this.page.totalPages = this.rows.length; // Update total count for pagination

 
}
openModalForReplaceKeyword(content,data){
  this.row_data = data 
  const options: NgbModalOptions = {
    size: 'md', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  // this.current_row = data
  this.modalService.open(content, options); // open the modal
}
getNewKeywordId(event){
  this.selected_new_keyword = event.name
}
replaceAssetKeyword(){
  let keywords = this.row_data?.name.split(",")
  let body={
    fromkeywords:keywords,
    tokeyword: this.selected_new_keyword,
    type:  ''
  }
  if(this.selected_keyword === 'skill'){
    body.type = 'skill_keywords'
  }
  if(this.selected_keyword === 'features'){
    body.type = 'features_keywords'
  }
  if(this.selected_keyword === 'projects'){
    body.type = 'projects_keywords'
  }

  this.apiService.replaceKeyword(body).subscribe((res:any)=>{
    if(res?.isSuccess){
      this.modalService.dismissAll()
      this.toastr.success("keyword replace successfully")
      this.page.pageNumber=0
      this.getAllAssets()
    }
    else this.toastr.error(res?.error)
  })
}

search(search_key){
  let type = ''
  let type2 = ''
  let type3 = ''
  if(this.selected_keyword === 'skill'){
    type = this.selected_keyword
  }
  if(this.selected_keyword === 'features'){
    type2 = this.selected_keyword
  }
  if(this.selected_keyword === 'projects'){
    type3 = this.selected_keyword
  }
  this.apiService.searchKeyword(type,type2,type3,search_key).subscribe((res:any)=>{
    this.pagedRows = res?.data
    this.page.totalPages = res?.data?.length
  })
}

getKeywords(){
    let type=''
    let type2=''
    let type3=''

  if(this.selected_keyword === 'skill'){
    type = this.selected_keyword 
  }
  if(this.selected_keyword === 'features'){
    type2 = this.selected_keyword 
  }
  if(this.selected_keyword === 'projects'){
    type3 = this.selected_keyword 
  }
  this.apiService.getAllKeywordsByType(type,type2,type3).subscribe((res:any)=>{
      res?.data?.map((item)=>{
        this.all_keywords.push({name:item})
    })
  })
}

goto(data){
  window.open(`/assets/list?search=${data?.name}`,'_blank')
}
 
}
